import ConfirmationModal from "../modals/ConfirmationModal";
import { ConfirmDisableCarriers } from "../modals/ConfirmDisableCarriers";
import CredentialsChazkiModal from "../modals/CredentialsChazkiModal";
import CredentialsOcaModal from "../modals/CredentialsOcaModal";
import CredentialsOcasaModal from "../modals/CredentialsOcasaModal";
import CredentialsRapiboyModal from "../modals/CredentialsRapiboyModal";
import {
  ICarrierChanged,
  IConfigurationModals,
  IModalsState,
} from "../../interfaces/configuration";
import {
  ANDREANI,
  CHAZKI,
  HOP,
  INTERNAL,
  OCA,
  OCASA,
  PICKIT,
  RAPIBOY,
  SOUTHPOST,
  URBANO,
} from "../../utils/constants";
import CredentialsHopModal from "../modals/CredentialsHopModal";
import CredentialsAndreaniModal from "../modals/CredentialsAndreaniModal";
import EditCarrierInfoModal from "../modals/EditCarrierInfoModal";
import CredentialsSouthpostModal from "../modals/CredentialsSouthpostModal";
import CredentialsUrbanoModal from "../modals/CredentialsUrbanoModal";
import CredentialsPickitModal from "../modals/CredentialsPickitModal";
import CredentialsPartnerModal from "../modals/CredentialsPartnerModal";

const CredentialsModal = ({
  carriers,
  carriersChanges,
  openModal: { type, open },
  setOpenModal,
  handleGetCarriers,
  handleCarriersChanges,
  handleSubmitChanges,
  entity,
}: IConfigurationModals) => {
  const handleCloseModal = () => setOpenModal({ open: false } as IModalsState);
  const getCredentialInfo = (carrierName: string) => {
    const [carrier] = carriers.filter(({ name }) => name === carrierName);

    // Tomamos la informacion del carrier modificado (si existe) o la del carrier original
    return carriersChanges[carrierName] || (carrier as ICarrierChanged);
  };
  if (entity === INTERNAL && type !== "confirmCancel")
    return (
      <EditCarrierInfoModal
        open={open}
        onClose={handleCloseModal}
        carrier={getCredentialInfo(type)}
        handleCarriersChanges={handleCarriersChanges}
      />
    );

  switch (type) {
  case OCA:
    return (
      <CredentialsOcaModal
        open={open}
        onClose={handleCloseModal}
        carrier={getCredentialInfo(OCA)}
        handleChangeOfConfig={handleCarriersChanges}
      />
    );
  case OCASA:
    return (
      <CredentialsOcasaModal
        open={open}
        onClose={handleCloseModal}
        carrier={getCredentialInfo(OCASA)}
        handleChangeOfConfig={handleCarriersChanges}
      />
    );
  case RAPIBOY:
    return (
      <CredentialsRapiboyModal
        open={open}
        onClose={handleCloseModal}
        carrier={getCredentialInfo(RAPIBOY)}
        handleChangeOfConfig={handleCarriersChanges}
      />
    );
  case CHAZKI:
    return (
      <CredentialsChazkiModal
        open={open}
        onClose={handleCloseModal}
        carrier={getCredentialInfo(CHAZKI)}
        handleChangeOfConfig={handleCarriersChanges}
      />
    );
  case HOP:
    return (
      <CredentialsHopModal
        open={open}
        onClose={handleCloseModal}
        carrier={getCredentialInfo(HOP)}
        handleChangeOfConfig={handleCarriersChanges}
      />
    );
  case ANDREANI:
    return (
      <CredentialsAndreaniModal
        open={open}
        onClose={handleCloseModal}
        carrier={getCredentialInfo(ANDREANI)}
        handleChangeOfConfig={handleCarriersChanges}
      />
    );
  case SOUTHPOST:
    return (
      <CredentialsSouthpostModal
        open={open}
        onClose={handleCloseModal}
        carrier={getCredentialInfo(SOUTHPOST)}
        handleChangeOfConfig={handleCarriersChanges}
      />
    );
  case URBANO:
    return (
      <CredentialsUrbanoModal
        open={open}
        onClose={handleCloseModal}
        carrier={getCredentialInfo(URBANO)}
        handleChangeOfConfig={handleCarriersChanges}
      />
    );
  case PICKIT:
    return (
      <CredentialsPickitModal
        open={open}
        onClose={handleCloseModal}
        carrier={getCredentialInfo(PICKIT)}
        handleChangeOfConfig={handleCarriersChanges}
      />
    );
  case "confirmCancel":
    return (
      <ConfirmationModal
        onSubmit={() => {
          handleGetCarriers();
          handleCloseModal();
        }}
        open={open}
        onClose={handleCloseModal}
      />
    );
  case "confirmDisableCarriers":
    return (
      <ConfirmDisableCarriers
        open={open}
        onClose={handleCloseModal}
        handleSubmit={handleSubmitChanges}
        carriers={Object.keys(carriersChanges)}
      />
    );
  default: {
    console.warn(
      "No se ha encontrado el modal correspondiente al nombre de un carrier legacy. Mostrando credenciales de partner."
    );
    return <CredentialsPartnerModal
      open={open}
      onClose={handleCloseModal}
      carrier={getCredentialInfo(type)}
      handleChangeOfConfig={handleCarriersChanges}
    />;
  }
  }
};

export default CredentialsModal;
